
const competitionHomeRutes = [
  {
    path: '/:usernameCompetition',
    component: () => import('../views/competition/CompetitionPage.vue'),
    children: [
      {
        path: '',
        name: 'competition-page',
        component: () => import('../views/competition/TorneosCompetitionPage.vue'),
      },
      {
        path: 'noticias',
        name: 'competition-page-noticias',
        component: () => import('../views/competition/NewsCompetitionPage.vue'),
      },
      {
        path: 'resultados',
        name: 'competition-page-resultados',
        component: () => import('../views/competition/ResultsCompetitionPage.vue'),
      },
      {
        path: 'calendario',
        name: 'competition-page-calendario',
        component: () => import('../views/competition/CalendarioCompetitionPage.vue'),
      },
      {
        path: 'campeones',
        name: 'competition-page-campeones',
        component: () => import('../views/competition/CampeonesCompetitionPage.vue'),
      },
    ]
  },
]

export default competitionHomeRutes